// import React from "react";
// import { Icon } from "@iconify/react";
// import video1 from "../../../assets/video/33bd06d6-cdec-463e-8b67-c70f630e35ae.MP4";
// import { useNavigate } from "react-router-dom";

// export default function ExploreCollection() {
// 	const navigate = useNavigate();
// 	const [data, setdata] = React.useState([]);

// 	// Fetch data if needed, or use passed data
// 	React.useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const response = await fetch(
// 					`https://admin.monsinidress.com/api/hero-section/brand`,
// 					{ brand: "Monsini" }
// 				);
// 				if (!response.ok) throw new Error("Failed to fetch data");
// 				const result = await response.json();
// 				setdata(result.data.products || []);
// 			} catch (error) {
// 				console.error("Error fetching data:", error);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	// --- Render the Explore Collection Component ---
// 	// Note: The data fetching logic can be adjusted based on your requirements
// 	if (!data || data.length === 0) {
// 		return <div className="text-center py-20">No data available</div>;
// 	}

// 	return (
// 		<div className="flex flex-col justify-center items-center py-20">
// 			<div className="text-center mb-16">
// 				<h2 className="text-5xl font-lora font-medium">
// 					Our Latest  Collection
// 				</h2>
// 			</div>

// 			{/* Two videos side by side */}
// 			<div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full  md:px-10 px-4 lg:px-32">
// 				<div className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden">
// 					<video
// 						src={video1}
// 						autoPlay
// 						loop
// 						muted
// 						playsInline
// 						className="absolute inset-0 w-full h-full object-cover object-[center_39%]"></video>

// 					{/* Gradient overlay */}

// 					{/* Text/Button */}
// 					<div className="absolute inset-0 flex items-end justify-start p-10">
// 						<button
// 							onClick={() => {
// 								navigate(`/prom`);
// 							}}
// 							className="cursor-pointer flex justify-center items-center px-8 py-4 font-lora text-white text-lg font-semibold tracking-wide rounded-full hover:bg-gray-900 transition duration-300 border border-white">
// 							EXPLORE MORE
// 							<span>
// 								<Icon
// 									icon="flowbite:arrow-right-outline"
// 									width="2rem"
// 									height="2rem"
// 									style={{ color: "white" }}
// 									className="ms-5 lg:block md:block hidden"
// 								/>
// 							</span>
// 						</button>
// 					</div>
// 				</div>
// 				<div className="relative lg:h-[900px] md:h-[700px] h-[600px] rounded-[15px] overflow-hidden ">
// 					<img
// 						src="https://demo.riskydress.com/images/2026/ENCHANTED-E/E40237%20%281%29.png"
// 						className="w-full h-full object-cover object-top   "
// 						alt=""
// 					/>

// 					{/* Text/Button */}
// 					<div className="absolute inset-0 flex items-end justify-start p-10">
// 						<button
// 							onClick={() => {
// 								navigate(`/evening/`);
// 							}}
// 							className=" cursor-pointer flex justify-center items-center px-8 py-4 font-lora text-white text-lg font-semibold tracking-wide rounded-full hover:bg-gray-900 transition duration-300 border border-white">
// 							EXPLORE MORE
// 							<span>
// 								<Icon
// 									icon="flowbite:arrow-right-outline"
// 									width="2rem"
// 									height="2rem"
// 									style={{ color: "white" }}
// 									className="ms-5 lg:block md:block hidden"
// 								/>
// 							</span>
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }

// import React from "react";
// import { Icon } from "@iconify/react";
// import video1 from "../../../assets/video/33bd06d6-cdec-463e-8b67-c70f630e35ae.MP4";
// import { useNavigate } from "react-router-dom";

// export default function ExploreCollection() {
// 	const navigate = useNavigate();
// 	const [data, setData] = React.useState([]);
// 	const [loading, setLoading] = React.useState(true);

// 	// Fetch data with POST request
// 	React.useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const response = await fetch(
// 					`https://admin.monsinidress.com/api/hero-section/brand`,
// 					{
// 						method: "POST",
// 						headers: {
// 							"Content-Type": "application/json",
// 						},
// 						body: JSON.stringify({ brand: "Monsini" }),
// 					}
// 				);
// 				if (!response.ok) throw new Error("Failed to fetch data");
// 				const result = await response.json();
// 				setData(result.data || []);
// 			} catch (error) {
// 				console.error("Error fetching data:", error);
// 				// Fallback to static data if API fails
// 				setData([
// 					{
// 						_id: "static-1",
// 						brand: "Prom Collection",
// 						media: [
// 							{
// 								url: video1,
// 								type: "video",
// 								filename: "prom-video.mp4",
// 							},
// 						],
// 						category: "prom",
// 					},
// 					{
// 						_id: "static-2",
// 						brand: "Evening Collection",
// 						media: [
// 							{
// 								url: "https://demo.riskydress.com/images/2026/ENCHANTED-E/E40237%20%281%29.png",
// 								type: "image",
// 								filename: "evening-dress.jpg",
// 							},
// 						],
// 						category: "evening",
// 					},
// 				]);
// 			} finally {
// 				setLoading(false);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	// Render media based on type
// 	const renderMedia = (item, index) => {
// 		const media = item.media?.[0];

// 		if (!media) {
// 			return (
// 				<div className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden bg-gray-200 flex items-center justify-center">
// 					<span className="text-gray-500">No media available</span>
// 				</div>
// 			);
// 		}

// 		if (media.type === "video") {
// 			return (
// 				<video
// 					src={media.url}
// 					autoPlay
// 					loop
// 					muted
// 					playsInline
// 					className="absolute inset-0 w-full h-full object-cover object-[center_39%]"
// 				/>
// 			);
// 		} else {
// 			return (
// 				<img
// 					src={media.url}
// 					className="w-full h-full object-cover object-top"
// 					alt={item.brand || "Collection"}
// 				/>
// 			);
// 		}
// 	};

// 	// Get navigation path based on category or brand
// 	const getNavigationPath = (item) => {
// 		if (item.category) {
// 			return `/${item.category}`;
// 		}
// 		if (item.brand?.toLowerCase().includes("prom")) {
// 			return "/prom";
// 		}
// 		if (item.brand?.toLowerCase().includes("evening")) {
// 			return "/evening";
// 		}
// 		return "/collection";
// 	};

// 	if (loading) {
// 		return <div className="text-center py-20">Loading collections...</div>;
// 	}

// 	if (!data || data.length === 0) {
// 		return (
// 			<div className="flex flex-col justify-center items-center py-20">
// 				<div className="text-center mb-16">
// 					<h2 className="text-5xl font-lora font-medium">
// 						Our Latest Collection
// 					</h2>
// 				</div>
// 				<div className="text-center py-10">
// 					No collections available at the moment
// 				</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<div className="flex flex-col justify-center items-center py-20">
// 			<div className="text-center mb-16">
// 				<h2 className="text-5xl font-lora font-medium">
// 					Our Latest Collection
// 				</h2>
// 			</div>

// 			{/* Dynamic grid based on data length */}
// 			<div
// 				className={`grid gap-6 w-full md:px-10 px-4 lg:px-32 ${
// 					data.length === 1
// 						? "grid-cols-1 max-w-4xl"
// 						: data.length >= 2
// 						? "grid-cols-1 md:grid-cols-2"
// 						: "grid-cols-1"
// 				}`}>
// 				{data.map((item, index) => (
// 					<div
// 						key={item._id || index}
// 						className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden">
// 						{renderMedia(item, index)}

// 						{/* Gradient overlay (optional) */}
// 						<div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

// 						{/* Text/Button */}
// 						<div className="absolute inset-0 flex items-end justify-start p-10">
// 							<button
// 								onClick={() => {
// 									navigate(getNavigationPath(item));
// 								}}
// 								className="cursor-pointer flex justify-center items-center px-8 py-4 font-lora text-white text-lg font-semibold tracking-wide rounded-full hover:bg-gray-900 transition duration-300 border border-white">
// 								EXPLORE {item.brand?.toUpperCase() || "COLLECTION"}
// 								<span>
// 									<Icon
// 										icon="flowbite:arrow-right-outline"
// 										width="2rem"
// 										height="2rem"
// 										style={{ color: "white" }}
// 										className="ms-5 lg:block md:block hidden"
// 									/>
// 								</span>
// 							</button>
// 						</div>
// 					</div>
// 				))}
// 			</div>
// 		</div>
// 	);
// }
import React from "react";
import { Icon } from "@iconify/react";
import video1 from "../../../assets/video/33bd06d6-cdec-463e-8b67-c70f630e35ae.MP4";
import { HashLink as Link } from "react-router-hash-link";
export default function ExploreCollection() {
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(true);

	// Initial static data
	const initialStaticData = [
		{
			_id: "static-1",
			brand: "Prom Collection",
			media: [
				{
					url: video1,
					type: "video",
					filename: "prom-video.mp4",
				},
			],
			category: "prom",
		},
		{
			_id: "static-2",
			brand: "Evening Collection",
			media: [
				{
					url: "https://demo.riskydress.com/images/2026/ENCHANTED-E/E40237%20%281%29.png",
					type: "image",
					filename: "evening-dress.jpg",
				},
			],
			category: "evening",
		},
	];

	// Set initial data immediately
	React.useEffect(() => {
		setData(initialStaticData);
	}, []);

	// Fetch data with POST request
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch(
					`https://admin.monsinidress.com/api/hero-section/brand`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ brand: "Monsini" }),
					}
				);
				if (!response.ok) throw new Error("Failed to fetch data");
				const result = await response.json();
				console.log("API Response:", result); // Debug log

				// Transform API data to match component structure
				if (result.data && result.data.length > 0) {
					const transformedData = result.data.map((item, index) => ({
						_id: item._id || `api-${index}`,
						brand: item.brand || "Collection",
						media: item.media || [],
						category: item.brand?.toLowerCase().includes("azure")
							? "evening"
							: "prom",
						// Add full URL for media
						transformedMedia:
							item.media?.map((mediaItem) => ({
								...mediaItem,
								url: mediaItem.url.startsWith("http")
									? mediaItem.url
									: `https://admin.monsinidress.com/${mediaItem.url}`,
							})) || [],
					}));
					console.log("Transformed Data:", transformedData); // Debug log
					setData(transformedData);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
				// Keep the initial static data on error
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	// Render media based on type
	const renderMedia = (item, index) => {
		// Use transformedMedia if available, otherwise use media
		const mediaArray = item.transformedMedia || item.media;
		const media = mediaArray?.[0];

		if (!media) {
			return (
				<div className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden bg-gray-200 flex items-center justify-center">
					<span className="text-gray-500">No media available</span>
				</div>
			);
		}

		if (media.type === "video") {
			return (
				<video
					src={media.url}
					autoPlay
					loop
					muted
					playsInline
					className="absolute inset-0 w-full h-full object-cover object-[center_39%]"
				/>
			);
		} else {
			return (
				<img
					src={media.url}
					className="w-full h-full object-cover object-top"
					alt={item.brand || "Collection"}
					onError={(e) => {
						// Fallback if image fails to load
						console.error("Image failed to load:", media.url);
						e.target.style.display = "none";
						e.target.parentElement.innerHTML = `
							<div class="w-full h-full flex items-center justify-center bg-gray-200">
								<span class="text-gray-500">Image not available</span>
							</div>
						`;
					}}
				/>
			);
		}
	};

	// Get navigation path based on category or brand

	// Get display text for button

	if (loading) {
		// Show initial static data while loading
		return (
			<div className="flex flex-col justify-center items-center py-20">
				<div className="text-center mb-16">
					<h2 className="text-5xl font-lora font-medium">
						Our Latest Collection
					</h2>
				</div>

				{/* Show initial static data grid */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full md:px-10 px-4 lg:px-32">
					{initialStaticData.map((item, index) => (
						<div
							key={item._id || index}
							className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden">
							{renderMedia(item, index)}

							{/* Gradient overlay */}
							<div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

							{/* Text/Button */}
							<div className="absolute inset-0 flex items-end justify-start p-10">
								<Link
									to={"#collection"}
									className="cursor-pointer flex justify-center items-center px-8 py-4 font-lora text-white text-lg font-semibold tracking-wide rounded-full hover:bg-gray-900 transition duration-300 border border-white">
									EXPLORE COLLECTION
									<span>
										<Icon
											icon="flowbite:arrow-right-outline"
											width="2rem"
											height="2rem"
											style={{ color: "white" }}
											className="ms-5 lg:block md:block hidden"
										/>
									</span>
								</Link>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}

	console.log("Current Data:", data); // Debug log

	return (
		<div className="flex flex-col justify-center items-center py-20">
			<div className="text-center mb-16">
				<h2 className="text-5xl font-lora font-medium">
					Our Latest Collection
				</h2>
			</div>

			{/* Dynamic grid based on data length */}
			<div
				className={`grid gap-6 w-full md:px-10 px-4 lg:px-32 ${
					data.length === 1
						? "grid-cols-1 max-w-4xl"
						: data.length >= 2
						? "grid-cols-1 md:grid-cols-2"
						: "grid-cols-1"
				}`}>
				{data.map((item, index) => (
					<div
						key={item._id || index}
						className="relative lg:h-[900px] md:h-[700px] h-[600px] w-full rounded-2xl overflow-hidden">
						{renderMedia(item, index)}

						{/* Gradient overlay */}
						<div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

						{/* Text/Button */}
						<div className="absolute inset-0 flex items-end justify-start p-10">
							<Link
								to={"#collection"}
								className="cursor-pointer flex justify-center items-center px-8 py-4 font-lora text-white text-lg font-semibold tracking-wide rounded-full hover:bg-gray-900 transition duration-300 border border-white">
								EXPLORE COLLECTION
								<span>
									<Icon
										icon="flowbite:arrow-right-outline"
										width="2rem"
										height="2rem"
										style={{ color: "white" }}
										className="ms-5 lg:block md:block hidden"
									/>
								</span>
							</Link>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
